import React from 'react'
import _ from 'lodash'
import { v4 as uuid } from 'uuid'

const defaultFormRegisterLeftTH = [
  {
    label: 'คำนำหน้า',
    value: 'prefix',
  },
  {
    label: 'ชื่อ (ภาษาไทยเท่านั้น)',
    value: 'first_name',
  },
  {
    label: 'นามสกุล (ภาษาไทยเท่านั้น)',
    value: 'last_name',
  },
  {
    label: 'ชื่อเล่น',
    value: 'nick_name',
  },
  {
    label: 'ตำแหน่งงาน',
    value: 'position',
  },
  {
    label: 'อายุ',
    value: 'age',
  },
  {
    label: 'หน่วยงานหรือบริษัท',
    value: 'organization',
  },
]
const defaultFormRegisterLeftEN = [
  {
    label: 'คำนำหน้า',
    value: 'prefix',
  },
  {
    label: 'ชื่อ (ภาษาไทยเท่านั้น)',
    value: 'first_name',
  },
  {
    label: 'นามสกุล (ภาษาไทยเท่านั้น)',
    value: 'last_name',
  },
  {
    label: 'Nickname',
    value: 'nick_name',
  },
  {
    label: 'Position',
    value: 'position',
  },
  {
    label: 'Age',
    value: 'age',
  },
  {
    label: 'Organization',
    value: 'organization',
  },
]
const defaultFormRegisterLeftENTH = [
  {
    label: 'คำนำหน้า',
    value: 'prefix',
  },
  {
    label: 'ชื่อ (ภาษาไทยเท่านั้น)',
    value: 'first_name',
  },
  {
    label: 'นามสกุล (ภาษาไทยเท่านั้น)',
    value: 'last_name',
  },
  {
    label: 'Nickname/ชื่อเล่น',
    value: 'nick_name',
  },
  {
    label: 'Position/ตำแหน่งงาน',
    value: 'position',
  },
  {
    label: 'Age/อายุ',
    value: 'age',
  },
  {
    label: 'Organization/หน่วยงานหรือบริษัท',
    value: 'organization',
  },
]
const defaultFormRegisterRightTH = [
  {
    label: 'Title',
    value: 'prefix_en',
  },
  {
    label: 'Name',
    value: 'first_name_en',
  },
  {
    label: 'Surname',
    value: 'last_name_en',
  },
  {
    label: 'Nickname',
    value: 'nick_name_en',
  },
  {
    label: 'อีเมล',
    value: 'email',
  },
  {
    label: 'ยืนยันอีเมล',
    value: 'confirm_email',
  },
  {
    label: 'หมายเลขโทรศัพท์มือถือ',
    value: 'mobile',
  },
  // {
  //   label: 'ประเภทการลงทะเบียน',
  //   value: 'complementary_type',
  // },
]
const defaultFormRegisterRightEN = [
  {
    label: 'Title',
    value: 'prefix_en',
  },
  {
    label: 'Name',
    value: 'first_name_en',
  },
  {
    label: 'Surname',
    value: 'last_name_en',
  },
  {
    label: 'Nickname',
    value: 'nick_name_en',
  },
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Confirm Email',
    value: 'confirm_email',
  },
  {
    label: 'Mobile',
    value: 'mobile',
  },
  // {
  //   label: 'ประเภทการลงทะเบียน',
  //   value: 'complementary_type',
  // },
]
const defaultFormRegisterRightENTH = [
  {
    label: 'Title',
    value: 'prefix_en',
  },
  {
    label: 'Name',
    value: 'first_name_en',
  },
  {
    label: 'Surname',
    value: 'last_name_en',
  },
  {
    label: 'Nickname',
    value: 'nick_name_en',
  },
  {
    label: 'Email/อีเมล',
    value: 'email',
  },
  {
    label: 'Confirm Email/ยืนยันอีเมล',
    value: 'confirm_email',
  },
  {
    label: 'Mobile/หมายเลขโทรศัพท์มือถือ',
    value: 'mobile',
  },
  // {
  //   label: 'ประเภทการลงทะเบียน',
  //   value: 'complementary_type',
  // },
]
const defaultForm = {
  th: {
    left: defaultFormRegisterLeftTH,
    right: defaultFormRegisterRightTH,
    data: _.reduce(
      [...defaultFormRegisterLeftTH, ...defaultFormRegisterRightTH],
      (res, n) => ({ ...res, [n.value]: { require: true } }),
      {},
    ),
  },
  en: {
    left: defaultFormRegisterLeftEN,
    right: defaultFormRegisterRightEN,
    data: _.reduce(
      [...defaultFormRegisterLeftEN, ...defaultFormRegisterRightEN],
      (res, n) => ({ ...res, [n.value]: { require: true } }),
      {},
    ),
  },
  'en-th': {
    left: defaultFormRegisterLeftENTH,
    right: defaultFormRegisterRightENTH,
    data: _.reduce(
      [...defaultFormRegisterLeftENTH, ...defaultFormRegisterRightENTH],
      (res, n) => ({ ...res, [n.value]: { require: true } }),
      {},
    ),
  },
}

const limitToShowTooltip = 50
const themeOptions = [
  {
    label: 'รูปแบบที่ 1 (outline)',
    value: 'outline',
  },
  {
    label: 'รูปแบบที่ 2 (outline-label)',
    value: 'outline-label',
  },
  {
    label: 'รูปแบบที่ 3 (outline-float)',
    value: 'outline-float',
  },
  {
    label: 'รูปแบบที่ 4 (fill)',
    value: 'fill',
  },
  {
    label: 'รูปแบบที่ 5 (fill-label)',
    value: 'fill-label',
  },
  {
    label: 'รูปแบบที่ 6 (fill-float)',
    value: 'fill-float',
  },
]
const agendaPositionOptions = [
  {
    label: 'ด้านบน',
    value: 'top',
  },
  {
    label: 'ด้านล่าง',
    value: 'bottom',
  },
]
const countdownPositionOptions = [
  {
    label: 'ไม่แสดง',
    value: null,
  },
  {
    label: 'ด้านบน',
    value: 'top',
  },
  {
    label: 'ใต้รูปปก',
    value: 'middle',
  },
  {
    label: 'ด้านล่าง',
    value: 'bottom',
  },
]

const genFormId = (prefix) => `${prefix}${uuid()}`

const requireDot = (e) => e?.require && <span className="require-dot text-danger">*</span>

const findKeyFormName = (customForm, key) => {
  const { ids, entities } = customForm

  const fileKey = _.split(key, 'file_')[1]
  const arrFormName = _.split(fileKey || key, '.')
  let customId = _.find(arrFormName, (id) => ~id.indexOf('custom-'))
  let optionId = _.find(arrFormName, (id) => ~id.indexOf('option-'))
  let subItemId = _.find(arrFormName, (id) => ~id.indexOf('sub-item-'))

  // case upload file
  if (fileKey) {
    const arrCheck = [customId, optionId, subItemId]
    if (_.filter(arrCheck).length !== 1) return null

    // upload within option
    if (optionId) {
      customId = _.find(ids, (customId) =>
        _.some(entities[customId].options.ids, (n) => n === optionId),
      )
      if (!customId) return null
      return `${customId}.${optionId}`
    }

    // upload within sub item
    if (subItemId) {
      customId = _.find(ids, (customId) => {
        const { options, with_other_sub_item } = entities[customId]
        return (
          _.some(options.ids, (optionId) => {
            const { sub_item } = options.entities[optionId]
            return sub_item && _.some(sub_item.ids, (n) => n === subItemId)
          }) || _.some(with_other_sub_item.ids, (n) => n === subItemId)
        )
      })
      if (!customId) return null
      return `${customId}.${subItemId}`
    }

    // upload normal
    if (!entities[customId]) return null
    return fileKey
  }

  if (
    !customId ||
    !entities[customId] ||
    (customId && subItemId && optionId) ||
    (subItemId && optionId)
  )
    return null

  if (subItemId) {
    const { options, with_other_sub_item } = entities[customId]
    const isFound =
      _.some(options.ids, (optionId) => {
        const { sub_item } = options.entities[optionId]
        return sub_item && _.some(sub_item.ids, (n) => n === subItemId)
      }) || _.some(with_other_sub_item.ids, (n) => n === subItemId)
    if (!isFound) return null
  } else if (optionId) {
    const option = entities[customId].options.entities[optionId]
    if (!option) return null
  }

  // case dynamic
  if (entities[customId].input_type === 'dynamic') {
    if (!optionId) return null
    const option = entities[customId].options.entities[optionId]
    return option.input_type === 'radio' ? `${key}.value` : key
  }

  // case radio
  if (entities[customId].input_type === 'radio') {
    if (subItemId) return key
    else if (optionId) return null
    return `${customId}.value`
  }

  // case other
  return key
}

const getMinNumber = (optionNumber, max, curr) => {
  if (curr === max) return max + 1
  if (_.includes(optionNumber, curr)) return getMinNumber(optionNumber, max, curr + 1)
  return curr
}

const getOptionNumber = (data) => {
  const { ids, entities } = data
  const prevOptionNumber = _.reduce(
    ids,
    (res, optionId) => {
      const { value } = entities[optionId]
      if (value.slice(0, 9) === 'ตัวเลือก ') {
        const currNumber = +_.replace(value, 'ตัวเลือก ', '')
        if (!_.isNaN(currNumber)) return [...res, currNumber]
      }
      return res
    },
    [],
  )
  return getMinNumber(prevOptionNumber, _.max(prevOptionNumber), 1)
}

const setStyleAttribute = (color, item) => {
  const { r, g, b, a } = item
  document.documentElement.style.setProperty(
    `--form-${color}-color`,
    `rgba(${r}, ${g}, ${b}, ${a})`,
  )
  if (_.includes(['active', 'invalid', 'btn-bg'], color)) {
    document.documentElement.style.setProperty(
      `--form-${color}-color-shadow`,
      `rgba(${r}, ${g}, ${b}, 0.3)`,
    )
  }
}

const disableRequire = (e) => {
  if (e.acceptanceForm) e.acceptanceForm.require = false
  if (e.defaultForm)
    for (let key in e.defaultForm) {
      if (key === 'type') continue
      e.defaultForm[key].require = false
    }
  if (e.customForm)
    for (const item of e.customForm) {
      const { input_type } = item
      item.require = false
      if (input_type === 'radio') {
        for (const option of item.options) {
          for (const sub_item of option.sub_item) sub_item.require = false
        }
        for (const sub_item of item.with_other_sub_item) {
          sub_item.require = false
        }
      } else if (input_type === 'dynamic') {
        for (const option of item.options) option.require = false
      }
    }
  return e
}

export {
  defaultForm,
  limitToShowTooltip,
  themeOptions,
  agendaPositionOptions,
  countdownPositionOptions,
  genFormId,
  requireDot,
  findKeyFormName,
  getOptionNumber,
  setStyleAttribute,
  disableRequire,
}
